<form class="col" *ngIf="(scopes$ | async) as scopes">
    <xcm-scope *ngIf="scopes.length>0" [scopes]="scopes" (onScopeSelected)="onScopeSelected($event)"></xcm-scope>
    <xcm-metagroup *ngIf="scope" [scope]="scope?.label" (onMetagroupSelected)="onMetagroupSelected($event)"></xcm-metagroup>
</form>
